import { dataHeartCancelSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeartCancelSolid = /*#__PURE__*/createIcon(dataHeartCancelSolid)
export default IconHeartCancelSolid
